/* eslint-disable no-restricted-globals */
/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable unicorn/prefer-query-selector */
/* eslint-disable unicorn/better-regex */
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { OpenInNew } from "@mui/icons-material";
import useViewModel from "./ViewModel";
import { PreventiveMEEntity } from "../../../../api/PreventiveME/Entity";
import { PreventiveMEDto } from "../../../../api/PreventiveME/Dto";
import { useSelector } from "react-redux";
import { selectProfile } from "../../../../store/profile/selector";
import ConfirmationDialog from "../../../../shared/Components/ConfirmationDialog";
import { enqueueSnackbar, useSnackbar } from "notistack";
import { UserInterfaceState } from "../../../../shared/Enum";
import { useNavigate } from "react-router-dom";

interface Prop {
  defaultValue?: PreventiveMEEntity;
  onSubmit(payload: PreventiveMEDto): void;
}

export function PreventiveMEForm({ defaultValue, onSubmit }: Prop) {
  const urlPattern =
    /^(https?:\/\/)?((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|(([0-9]{1,3}\.){3}[0-9]{1,3}))(:[0-9]{1,5})?(\/[-a-zA-Z0-9()@:%_+.~#?&/=]*)?(\?[;&a-zA-Z0-9%_+.~#?&/=]*)?(\#[-a-zA-Z0-9()@:%_+.~#?&/=]*)?$/i;
  const profile = useSelector(selectProfile);
  const { data, method } = useViewModel();
  const snackbar = useSnackbar();
  const [formData, setFormData] = useState<PreventiveMEDto>({
    binusianId: profile.binusianId,
    id: "",
    type: "DAILY",
    link: "",
    location: "",
    name: "",
  });
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [validation, setValidation] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    method.onGetLocationList();
    if (defaultValue) {
      setFormData({
        binusianId: profile.binusianId,
        id: defaultValue.id,
        link: defaultValue.link,
        location: defaultValue.location,
        name: defaultValue.name,
        type: defaultValue.type,
      });
    }
  }, [defaultValue]);

  useEffect(() => {
    if (UserInterfaceState.isError(data.uiState)) {
      enqueueSnackbar({
        message:
          "Oops, something went wrong. Please try again later. If the issue persists, try refreshing the page or restarting the app.",
        variant: "error",
      });
    }
  }, [data.uiState]);

  const handleFormData = (name: string, value: any) => {
    setFormData((prevState) => ({ ...prevState, [name]: value }));
  };

  useEffect(() => {
    if (data.locationList.length > 0 && !defaultValue) {
      handleFormData("location", data.locationList[0].locationId);
    }
  }, [data.locationList]);

  return (
    <Box className="flex flex-col w-full md:px-8 md:py-1 gap-10">
      <ConfirmationDialog
        description={`Are you sure you want to ${
          defaultValue ? "update" : "create"
        } this
            data?`}
        onCancel={() => setConfirmationDialog(false)}
        onClose={() => setConfirmationDialog(false)}
        onSubmit={() => {
          setConfirmationDialog(false);
          onSubmit(formData);
        }}
        open={confirmationDialog}
      />
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">Location Name</Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <Select
              value={formData.location}
              onChange={(e) => handleFormData("location", e.target.value)}
              className="w-full md:w-1/6"
            >
              {data.locationList.map((e) => (
                <MenuItem value={e.locationId}>{e.locationName}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Form Preventive Management Name
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              className="md:w-1/2"
              value={formData.name}
              onChange={(e) => handleFormData("name", e.target.value)}
              error={validation && formData.name == ""}
              helperText={
                validation && formData.name == "" && "Form Name is required!"
              }
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} className="flex">
          <FormControl className="self-center flex gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Form Preventive Management Type
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={formData.type}
              onChange={(e) => handleFormData("type", e.target.value)}
            >
              <Box className="flex">
                <FormControlLabel
                  value="DAILY"
                  control={<Radio />}
                  label="Form Harian"
                />
                <FormControlLabel
                  value="QUARTERLY"
                  control={<Radio />}
                  label="Form 3 Bulanan"
                />
              </Box>
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl className="flex flex-col gap-4">
            <Box className="flex gap-2">
              <Typography className="text-lg">
                Form Preventive Management Link
              </Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <Box className="flex md:w-1/2">
              <TextField
                id="filled-basic"
                variant="outlined"
                className="w-full"
                InputProps={{
                  style: {
                    paddingRight: 0,
                  },
                  endAdornment: (
                    <Button
                      className="h-full ml-2"
                      variant="contained"
                      onClick={() => {
                        if (urlPattern.test(formData.link)) {
                          const toOpen = window.open(
                            formData.link,
                            "_blank",
                            "noopener,noreferrer"
                          );
                          if (toOpen) toOpen.opener = null;
                        } else {
                          snackbar.enqueueSnackbar("Please type a valid URL", {
                            variant: "error",
                          });
                        }
                      }}
                    >
                      <OpenInNew />
                    </Button>
                  ),
                }}
                value={formData.link}
                onChange={(e) => handleFormData("link", e.target.value)}
                error={
                  validation &&
                  (formData.link == "" || !urlPattern.test(formData.link))
                }
                helperText={
                  validation &&
                  (formData.link === "" || !urlPattern.test(formData.link)) &&
                  (formData.link === ""
                    ? "Form URL is required!"
                    : "Please enter a valid URL.")
                }
              />
            </Box>
          </FormControl>
        </Grid>
      </Grid>
      <Box className="flex justify-center gap-5 mt-4">
        <Button
          variant="contained"
          className="capitalize py-3 px-10 text-lg"
          size="large"
          onClick={() => navigate("/preventive-me")}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          className="capitalize py-3 px-10 text-lg"
          size="large"
          onClick={() => {
            if (
              formData.link == "" ||
              formData.name == "" ||
              !urlPattern.test(formData.link)
            ) {
              setValidation(true);
            } else {
              setConfirmationDialog(true);
            }
          }}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
}
